import { Component, OnInit, HostListener } from '@angular/core';
import { SharedDataService } from '../../service/shared-data.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import { StaticDataService } from '../../service/static-data.service';

@Component({
  selector: 'app-translated-wire',
  templateUrl: './translated-wire.component.html',
  styleUrls: ['./translated-wire.component.scss']
})


export class TranslatedWireComponent implements OnInit {
  activeFeed;
  domainConfig = null;
  isTranslationFeedEnabled: boolean;
  isEnglishTranslationFeedEnabled: boolean;
  domainsEnabled: string='';
  constructor(
    private sharedService: SharedDataService,
  private router: Router,
    private gaService:GoogleAnalyticsService
  ) {
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.isTranslationFeedEnabled = this.sharedService.isdomainConfig('feeds','showTranslationFeed');
    this.isEnglishTranslationFeedEnabled = this.sharedService.isdomainConfig('feeds','showEnglishTranslationFeed');
    this.domainsEnabled = (this.domainConfig['config'] && this.domainConfig['config']['feeds'] && 
         this.domainConfig['config']['feeds']['domainsEnabled'])?
                  this.domainConfig['config']['feeds']['domainsEnabled']:"";
    if(this.isTranslationFeedEnabled) {
      this.activeFeed = 'translationFeedHT';
    } else if(this.isEnglishTranslationFeedEnabled){
      this.activeFeed = 'translationFeedBangla';
    }
    // this.isHindiFeedEnabled = this.sharedService.isdomainConfig('feeds','showHindiFeed');

  }
  ngOnInit() {
    this.sharedService.setTitle('Feeds');
    this.snowplowAnalytics('Agency Feed');
  }

  snowplowAnalytics(name) {
    let feedName=name;
    let eventCategory='Feeds';
    let eventAction=sessionStorage.getItem(StaticDataService.tenantName) +" " +feedName +' Listing';
    let eventLabel='';
    let eventValue=null;
   this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
    const ur = this.router.routerState.snapshot.url;
    this.sharedService.analyticsCall((window.location.origin + ur), 'tab', [], name);
  }

  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }
}
